/**
 * Acciones auditables del sistema.
 *
 * Por que vive aqui y no como enum de Mongoose: en el sistema anterior el enum
 * estaba en el modelo, asi que toda accion nueva que alguien olvidara registrar
 * hacia que la peticion respondiera 400 en produccion. Aqui la lista es una
 * constante compartida, el tipo se deriva de ella y el compilador atrapa el
 * error antes de que exista la peticion.
 */
export const ACCIONES_AUDITORIA = [
    // Ciclo de vida generico de cualquier entidad
    'CREAR',
    'ACTUALIZAR',
    'ELIMINAR_LOGICO',
    'RESTAURAR',
    // Lectura y salida de informacion (rastro de acceso a datos clinicos)
    'CONSULTAR',
    'EXPORTAR',
    'IMPRIMIR',
    // Documentos firmados
    'FIRMAR',
    'REFIRMAR',
    'CANCELAR_DOCUMENTO',
    // Archivos
    'SUBIR_ARCHIVO',
    'DESCARGAR_ARCHIVO',
    'ELIMINAR_ARCHIVO',
    // Acceso y cuentas
    'INICIAR_SESION',
    'INICIAR_SESION_FALLIDO',
    'CERRAR_SESION',
    'CAMBIAR_CONTRASENA',
    'SOLICITAR_RESTABLECIMIENTO',
    'RESTABLECER_CONTRASENA',
    'ASIGNAR_CONTRASENA_PROVISIONAL',
    'INVITAR_USUARIO',
    'CANCELAR_INVITACION',
    // Portal de la paciente (F4.2)
    'INVITAR_AL_PORTAL',
    'ACTIVAR_PORTAL',
    'REVOCAR_ACCESO_PORTAL',
    // Planes (F4.5)
    'PUBLICAR_PLAN',
    'CAMBIAR_ESTADO_PLAN',
    // Seguimiento (F4.7)
    'REVISAR_MEDICION',
    'CORREGIR_MEDICION',
    // Mensajeria (F4.8)
    'ENVIAR_MENSAJE',
    'ASIGNAR_CONVERSACION',
    'CAMBIAR_ROL',
    'DESACTIVAR_USUARIO',
    // Organizacion
    'CREAR_ORGANIZACION',
    'ACTUALIZAR_MARCA',
    'ACTUALIZAR_CONFIGURACION',
    // Modulos contratados (entitlements)
    'HABILITAR_MODULO',
    'RETIRAR_MODULO',
    // Publicacion de resultados al portal (F3.4)
    'PUBLICAR_RESULTADO',
    'RETIRAR_PUBLICACION',
    'COMPARTIR_DOCUMENTO',
    'RETIRAR_DOCUMENTO_COMPARTIDO',
    'CAMBIAR_SUSCRIPCION',
    'RECONCILIAR_USO',
    'REMITIR_PACIENTE',
    'REVISAR_CREDENCIAL',
    'CAMBIAR_POLITICA_DE_ACCESO',
    'AUTORIZAR_SOPORTE',
    'REVOCAR_SOPORTE',
];
/**
 * Entidades sobre las que se audita. Se usa como discriminante en las consultas
 * del rastro y en los indices.
 */
export const ENTIDADES_AUDITABLES = [
    'Organizacion',
    'Usuario',
    'Paciente',
    'HistoriaClinica',
    'Colposcopia',
    'ConfiguracionAgenda',
    'Cita',
    'Receta',
    'NotaEvolucion',
    'NotaEgreso',
    'NotaAclaratoria',
    'Consentimiento',
    'Archivo',
    'Sesion',
    'Entitlement',
    // Nucleo clinico (F2.1)
    'Encuentro',
    'Observacion',
    'Problema',
    'Alergia',
    'Medicacion',
    // Motor de especialidades (F2.6)
    'Plantilla',
    'DocumentoClinico',
    // Estudios (F3.4)
    'OrdenEstudio',
    'Estudio',
    // Reporte firmado de un estudio (F3.5)
    'ReporteEstudio',
    // Avisos a pacientes (F4.1)
    'PreferenciaDeAvisos',
    'Aviso',
    // Portal de la paciente (F4.2)
    'InvitacionPortal',
    'VinculoPaciente',
    // Planes de atencion (F4.5)
    'PlanAtencion',
    'PlantillaDeAlimentacion',
    // Seguimiento (F4.7)
    'Cuestionario',
    // Mensajeria (F4.8)
    'Conversacion',
    // Documentos compartidos con la paciente (F4.9)
    'DocumentoCompartido',
    // Suscripcion del consultorio (F5.1)
    'Suscripcion',
    // Organizacion interna (F5.5)
    'Sucursal',
    'Equipo',
    'VinculoAsistencial',
    'Credencial',
    // Acceso excepcional de soporte (F5.6)
    'AccesoSoporte',
    // Captura del colposcopio (ADR-017)
    'CalibracionDeDispositivo',
];
//# sourceMappingURL=auditoria.js.map